import { Component, ViewChild, computed, inject } from '@angular/core';
import { AlertController, IonRefresher, ModalController, NavController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { map, startWith, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { League } from '../_shared/models/league.model';
import { CreateLeagueComponent } from './create-league/create-league.component';
import { LeagueService } from './league.service';
import { Observable } from 'rxjs-compat';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
    selector: 'app-leagues',
    templateUrl: './leagues.page.html',
    styleUrls: ['./leagues.page.scss'],
})
export class LeaguesPage {
    authService = inject(AuthService);
    private leagueService = inject(LeagueService);
    private alertController = inject(AlertController);
    private navController = inject(NavController);
    private modalController = inject(ModalController);
    private translateService = inject(TranslateService);

    @ViewChild('refresher') refresher: IonRefresher;

    isPublic = false;
    private refreshLeagues$ = new Subject<void>();
    private leagues$: Observable<League[]> = this.refreshLeagues$.pipe(
        startWith(undefined),
        switchMap(() => this.leagueService.getLeagues(this.isPublic)),
        map(res => res.data),
        tap(() => this.refresher.complete())
    )
    leagues = toSignal(this.leagues$);

    loaded = computed(() => {
        return !!this.leagues()?.length
    })
    
    noLeaguesText = this.translateService.instant('You don\'t have any leagues. You can view public leagues by switching the toggle at the bottom of the page.');
    noTeamEventsText = this.translateService.instant('You don\'t have any team events saved. You can view public events by switching the toggle at the bottom of the page.');

    doRefresh() {
        this.refreshLeagues$.next();
    }

    async createLeague() {        
        if (this.authService.authUserSignal().role.value > 399) {
            const modal = await this.modalController.create({
                component: CreateLeagueComponent,
            });

            await modal.present();

            const { data } = await modal.onDidDismiss();

            if (data) {
                this.leagues().unshift(data);
            }

        } else {
            const alert = await this.alertController.create({
                header: this.translateService.instant('Contact us'),
                message: this.translateService.instant('If you would like to have live scoring for your league or to have unique link for all team matches contact us via feedback@ionsport.com or send us a message through the feedback form.'),
                buttons: [
                    {
                        text: this.translateService.instant('Send feedback'),
                        handler: () => {
                            this.navController.navigateForward('feedback');
                        }
                    },
                    {
                        text: this.translateService.instant('Close'),
                        role: 'cancel'
                    }
                ]
            });

            await alert.present();
        }

    }

}
